import cx from 'classnames';
import { css } from 'emotion';
import React, { PureComponent } from 'react';
import { colors, fontSize, mq } from './../../../../css';
import ExpertKnowledge from './expert_knowledge.svg';
import ExternalData from './external_data.svg';
import Forecast from './forecast.svg';
import HistoricalData from './historical_data.svg';
import InternalData from './internal_data.svg';
import Logo from './logo.svg';
import Monitoring from './monitoring.svg';
import Rules from './rules.svg';
import Segmentation from './segmentation.svg';

export default class EcoSystem extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={s.scaler}>
                <div className={s.wrapper}>
                    <Logo className={s.logo} />
                    <div
                        className={cx(s.element, s.expertKnowledge)}
                        data-tag="Expert Knowledge">
                        <ExpertKnowledge />
                    </div>
                    <div
                        className={cx(s.element, s.externalData)}
                        data-tag="External Data">
                        <ExternalData />
                    </div>
                    <div
                        className={cx(s.element, s.segmentation)}
                        data-tag="Segmentation">
                        <Segmentation />
                    </div>
                    <div
                        className={cx(s.element, s.internalData)}
                        data-tag="Internal Data">
                        <InternalData />
                    </div>
                    <div
                        className={cx(s.element, s.monitoring)}
                        data-tag="Monitoring">
                        <Monitoring />
                    </div>
                    <div
                        className={cx(s.element, s.forecast)}
                        data-tag="Forecast">
                        <Forecast />
                    </div>
                    <div className={cx(s.element, s.rules)} data-tag="Rules">
                        <Rules />
                    </div>
                    <div
                        className={cx(s.element, s.historicalData)}
                        data-tag="Historical Data">
                        <HistoricalData />
                    </div>
                </div>
            </div>
        );
    }
}

const s = {};

s.scaler = css`
    width: 100%;
    height: 100%;
    position: relative;
    ${mq({
        transform: [
            'scale(0.4)',
            'scale(0.6)',
            'scale(0.9)',
            'scale(0.6)',
            'scale(0.7)',
            'scale(1)',
        ],
    })};
`;

s.wrapper = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 550px;
`;

s.logo = css`
    position: absolute;
    top: 230px;
    left: 50%;
    transform: translateX(-50%);
    width: 250px;
    height: 100px;
`;

s.element = css`
    position: absolute;
    width: 130px;
    height: 130px;
    transform: translateX(-50%);
    &::after {
        content: attr(data-tag);
        position: absolute;
        top: calc(100% + 10px);
        width: 100%;
        text-align: center;
        color: ${colors.blue};
        font-size: ${fontSize(14)};
    }
    svg {
        position: absolute;
        width: 100%;
        height: 90%;
        bottom: 0;
    }
`;

s.expertKnowledge = css`
    top: 200px;
    left: calc(50% - 290px);
`;

s.externalData = css`
    top: 30px;
    left: calc(50% - 170px);
    svg {
        /* bottom: -15px; */
    }
`;

s.segmentation = css`
    top: 0;
    left: 50%;
`;

s.internalData = css`
    top: 30px;
    left: calc(50% + 170px);
    svg {
        /* bottom: -15px; */
    }
`;

s.monitoring = css`
    top: 200px;
    left: calc(50% + 290px);
`;

s.forecast = css`
    top: 370px;
    left: calc(50% + 170px);
`;

s.rules = css`
    top: 400px;
    left: 50%;
`;

s.historicalData = css`
    top: 370px;
    left: calc(50% - 170px);
`;



// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/ecoSystem.complex.component.js